'use es6';

import userInfo from 'hub-http/userInfo';
export var getUserInfo = userInfo;